export function RewardIcon() {
  return (
    <svg
      fill="none"
      height="95"
      viewBox="0 0 146 95"
      width="146"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M75 6C44.624 6 20 30.624 20 61c0 12.082 3.896 23.254 10.5 32.33h89C126.104 84.253 130 73.081 130 61c0-30.376-24.624-55-55-55z"
        fill="#F2ECE1"
      />
      <rect fill="#F2ECE1" height="2" rx="1" width="99" x="35" y="93" />
      <rect fill="#F2ECE1" height="2" rx="1" width="39" y="93" />
      <rect fill="#F2ECE1" height="2" rx="1" width="9" x="137" y="93" />
      <path
        d="M49.125 45.781H99.75v45H49.125v-45z"
        fill="url(#paint0_linear)"
      />
      <path d="M63.629 45.781L49.125 57.836V45.781h14.504z" fill="#D18D28" />
      <path
        d="M99.219 7.031a2.812 2.812 0 100-5.624 2.812 2.812 0 000 5.624zM88.5 45.781a2.812 2.812 0 100-5.625 2.812 2.812 0 000 5.625z"
        fill="#43DCFE"
      />
      <path
        d="M99.406 23.625a1.407 1.407 0 01-.994-2.4l2.812-2.813a1.408 1.408 0 012.401.994c0 .373-.148.731-.412.995l-2.812 2.812a1.411 1.411 0 01-.995.412zM35.219 27.625a1.4 1.4 0 01-.995-.412l-2.812-2.812a1.406 1.406 0 011.989-1.99l2.812 2.813a1.406 1.406 0 01-.994 2.401z"
        fill="#00BAFF"
      />
      <path
        d="M25.213 54.653l43.256-35.944 8.986 10.814L34.2 65.467l-8.986-10.814z"
        fill="url(#paint1_linear)"
      />
      <path d="M49.125 62.656H99.75v11.25H49.125v-11.25z" fill="#00BAFF" />
      <path d="M68.813 45.781h11.25v45h-11.25v-45z" fill="#00BAFF" />
      <path
        d="M81.399 11.289l2.34 7.203h7.574a1.404 1.404 0 01.825 2.54l-6.128 4.452 2.34 7.203a1.404 1.404 0 01-2.16 1.57l-6.127-4.452-6.128 4.452a1.404 1.404 0 01-2.16-1.57l2.34-7.203-6.127-4.453a1.404 1.404 0 01.825-2.539h7.574l2.34-7.203a1.404 1.404 0 012.672 0z"
        fill="url(#paint2_linear)"
      />
      <path
        d="M104.613 29.426l5.652 6.25-4.174 3.774-5.651-6.25 4.173-3.774zM46.404 13.795l6.477-5.383 3.595 4.326-6.477 5.382-3.595-4.325z"
        fill="#12EEB1"
      />
      <path
        d="M70.219 13.438a1.404 1.404 0 01-.995-.412l-1.406-1.407a1.408 1.408 0 011.989-1.988l1.406 1.406a1.407 1.407 0 01-.994 2.4z"
        fill="#FAA6B2"
      />
      <path
        d="M58.969 30.313a2.812 2.812 0 100-5.625 2.812 2.812 0 000 5.625z"
        fill="#12EEB1"
      />
      <path
        d="M99.219 0a4.22 4.22 0 100 8.438 4.22 4.22 0 000-8.438zm0 5.625a1.406 1.406 0 110-2.812 1.406 1.406 0 010 2.812zM110.406 19.625a1.404 1.404 0 00.995-.412l2.812-2.812a1.405 1.405 0 10-1.989-1.99l-2.812 2.813a1.402 1.402 0 00-.305 1.533 1.406 1.406 0 001.299.868zM99.75 44.375h-7.273a4.22 4.22 0 10-7.954 0H61.787l10.36-8.611c.308.116.634.176.963.177a2.801 2.801 0 001.652-.547l5.3-3.851 5.301 3.851a2.81 2.81 0 004.325-3.141l-2.025-6.232 5.302-3.851a2.81 2.81 0 00-1.653-5.084H84.76l-2.026-6.231a2.81 2.81 0 00-5.345 0l-2.024 6.231h-6.553a2.76 2.76 0 00-2.562 1.659c-.06.036-.117.076-.172.12l-5.634 4.683a4.215 4.215 0 00-5.63 4.68L24.32 53.572a1.405 1.405 0 00-.183 1.98l8.989 10.816a1.407 1.407 0 001.98.182L47.72 56.067v34.714a1.406 1.406 0 001.406 1.406H99.75a1.404 1.404 0 001.406-1.406v-45a1.405 1.405 0 00-1.406-1.406zM98.344 61.25H81.469V47.187h16.875V61.25zm0 11.25H81.469v-8.438h16.875V72.5zm-11.25-29.531a1.405 1.405 0 112.81 0 1.405 1.405 0 01-2.81 0zM50.53 64.062h16.875V72.5H50.531v-8.438zM76.387 19.9a1.406 1.406 0 001.337-.972l2.338-7.197 2.338 7.197a1.407 1.407 0 001.338.972h7.566l-6.121 4.447a1.406 1.406 0 00-.51 1.572l2.337 7.196-6.121-4.447a1.406 1.406 0 00-1.653 0l-6.121 4.447 2.338-7.196a1.406 1.406 0 00-.511-1.572l-6.122-4.447h7.567zm-17.418 6.195a1.406 1.406 0 11-1.164 2.194 1.394 1.394 0 00-.183-.385 1.406 1.406 0 011.347-1.81zm-24.58 37.394l-7.19-8.651 29.033-24.13a4.215 4.215 0 006.39-5.312l4.213-3.501c.102.1.21.192.326.276l5.301 3.851-2.025 6.232c-.144.438-.18.905-.102 1.36L34.39 63.488zm24.014-16.3h9.003V61.25H50.531v-7.52l7.872-6.542zM50.53 75.311h16.875v14.063H50.531V75.312zM70.22 89.376V47.187h8.437v42.188H70.22zm11.25 0V75.312h16.875v14.063H81.469zM105.623 28.463a1.41 1.41 0 00-1.987-.1l-4.173 3.772a1.406 1.406 0 00-.1 1.986l5.648 6.249a1.404 1.404 0 001.986.1l4.173-3.772a1.42 1.42 0 00.462-.972 1.412 1.412 0 00-.362-1.014l-5.647-6.249zm.532 8.977l-3.762-4.162 2.086-1.886 3.762 4.163-2.086 1.886zM51.985 7.325l-6.478 5.383a1.407 1.407 0 00-.182 1.98l3.595 4.327a1.406 1.406 0 001.98.182l6.478-5.383a1.407 1.407 0 00.183-1.98l-3.596-4.327a1.406 1.406 0 00-1.98-.182zm-1.8 8.81l-1.798-2.162 4.314-3.585L54.5 12.55l-4.315 3.586zM69.224 13.026a1.406 1.406 0 001.99-1.99l-1.407-1.405a1.405 1.405 0 10-1.989 1.988l1.406 1.407z"
        fill="#1F233F"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear"
          x1="74.438"
          x2="74.438"
          y1="45.781"
          y2="90.781"
        >
          <stop stopColor="#FFCB66" />
          <stop offset="1" stopColor="#FFA800" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear"
          x1="67.125"
          x2="28.5"
          y1="26.375"
          y2="58.625"
        >
          <stop stopColor="#FFCB66" />
          <stop offset="1" stopColor="#FFA800" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear"
          x1="80.063"
          x2="80.063"
          y1="10.318"
          y2="34.525"
        >
          <stop stopColor="#FFCB66" />
          <stop offset="1" stopColor="#FFA800" />
        </linearGradient>
      </defs>
    </svg>
  );
}
